import { onlineManager } from "@tanstack/react-query";

/**
 * Lazy route import functions. Preloading while online caches Vite/webpack chunks
 * in the browser so navigation still works after the device goes offline (web
 * only — native Capacitor bundles ship with the app shell).
 */
const ROUTE_CHUNK_LOADERS = [
  () => import("features/farmOverview/FarmView"),
  () =>
    import("features/farmOverview/FarmInput").then((m) => ({
      default: m.FarmInput,
    })),
  () => import("features/fieldDetail/FieldView"),
  () => import("features/fieldEdit/FieldInput"),
  () => import("features/farmOverview/FieldsListScreen"),
  () => import("features/animalGroupDetail/AnimalGroupDetail"),
  () => import("features/animalGroupDetail/AnimalGroupInput"),
  () =>
    import("features/insights/FarmInsights").then((m) => ({
      default: m.FarmInsights,
    })),
  () => import("features/insights/FarmInsightsDrawer"),
  () =>
    import("features/insights/ProjectInsightsMetrics").then((m) => ({
      default: m.ProjectInsightsMetrics,
    })),
  () =>
    import("features/insights/AccessibleFarmsInsights").then((m) => ({
      default: m.AccessibleFarmsInsights,
    })),
  () => import("features/programmesActions/ProgrammesList"),
  () => import("features/programmesActions/ProgrammesDrawer"),
  () => import("features/programmesActions/ProgrammeDetailsWeb"),
  () => import("features/programmesActions/ProgrammesDetailsDrawer"),
  () => import("features/programmesActions/ActionDetails"),
  () => import("features/programmeInvitations/ProgrammeConsentPage"),
  () => import("features/planner").then((m) => ({ default: m.Planner })),
  () => import("features/planner").then((m) => ({ default: m.PlannerDrawer })),
  () => import("features/fileManagement/FileManagement"),
  () => import("features/fileManagement/FileManagementDetail"),
  () => import("features/fileManagement/AddNewFile"),
  () => import("features/combinedInputsOutputs/RecordsPage"),
] as const;

let preloadStarted = false;

export function preloadRouteChunksWhenOnline(): void {
  if (!onlineManager.isOnline() || preloadStarted) return;
  preloadStarted = true;
  void Promise.allSettled(ROUTE_CHUNK_LOADERS.map((load) => load()));
}
